import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface AuthState {
  name: string
  email: string
  access_token: string
  refresh_token: string
  role: string
  tokenExpiry: number | null
}

const initialState: AuthState = {
  name: '',
  email: '',
  access_token: '',
  refresh_token: '',
  role: '',
  tokenExpiry: null,
}

export const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setAuthenticatedUser: (state: AuthState, { payload }: PayloadAction<Partial<AuthState>>) => {
      if (payload.name !== undefined) state.name = payload.name
      if (payload.email !== undefined) state.email = payload.email
      if (payload.access_token !== undefined) state.access_token = payload.access_token
      if (payload.refresh_token !== undefined) state.refresh_token = payload.refresh_token
      if (payload.role !== undefined) state.role = payload.role
      if (payload.tokenExpiry !== undefined) state.tokenExpiry = payload.tokenExpiry
    },
    updateTokens: (state: AuthState, { payload }: PayloadAction<{ access_token: string; refresh_token?: string; tokenExpiry?: number }>) => {
      state.access_token = payload.access_token
      if (payload.refresh_token) state.refresh_token = payload.refresh_token
      if (payload.tokenExpiry) state.tokenExpiry = payload.tokenExpiry
    },
    resetState: (state: AuthState) => {
      state.access_token = ''
      state.refresh_token = ''
      state.name = ''
      state.email = ''
      state.role = ''
      state.tokenExpiry = null
      localStorage.removeItem('user')
    },
  },
})

export const { setAuthenticatedUser, updateTokens, resetState } = authSlice.actions
export const authReducer = authSlice.reducer
export const selectAuthenticatedUser = (state: RootState) => state.authReducer
